import * as addressList from './Address.service';
export const AddressService = {
  ...addressList,
};
